
export const sentryRelease = 'gosu-box@BOX-20251021-01'; 

